import * as React from 'react';

import { Guide, GuideStep } from '../guide';

export const stepTypeColors = {
  boil: '#F8E71C',
  grind: '#8B572A',
  bloom: '#2CD1E6',
  pour: '#294FBB',
  prepare: '#03A238',
  wait: '#353535',
  stir: '#6A6A6A',
};

const totalAngle = 360;
const width = 200;
const circleRadius = width / 2 - 2;

const polarToCartesian = (
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number,
) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
};

const describeArc = (
  x: number,
  y: number,
  radius: number,
  startAngle: number,
  endAngle: number,
) => {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  const d = [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y,
  ].join(' ');

  return d;
};

const renderCirclePaths = (guide: Guide) => {
  if (guide.steps.length === 0) {
    return null;
  }

  let timeAt = 0;
  const totalDuration = guide.steps.reduce((val: number, step: GuideStep) => {
    return val + step.time_duration;
  }, 0);

  return guide.steps.map((step: GuideStep) => {
    const start = (timeAt / totalDuration) * totalAngle;
    const end = ((timeAt + step.time_duration) / totalDuration) * totalAngle;
    const colour: string = stepTypeColors[step.type];

    timeAt = timeAt + step.time_duration;

    return (
      <path
        key={`${start}-${end}-${colour}`}
        d={describeArc(width / 2, width / 2, circleRadius, start, end)}
        fill="none"
        stroke={colour}
        strokeWidth="4"
      />
    );
  });
};

export interface GuideGraphProps {
  guide: Guide;
}

const imageURL = (guide: Guide): string => {
  if (guide.image_identifier && guide.image_identifier.includes('http')) {
    return guide.image_identifier;
  }

  // TODO: Company?

  return `/images/methods/${guide.method || 'add'}.png`;
};

export const GuideGraph = ({ guide }: GuideGraphProps) => {
  const secondImage = guide.company
    ? guide.company.image_identifier
    : guide.user.image_url;

  return (
    <div className="guideStamp">
      <img
        className="guideOwner w3 h3"
        src={secondImage}
        alt={guide.user.name}
      />
      <img alt={guide.method} className="guideMethod" src={imageURL(guide)} />
      <svg className="guideStepsCircle" viewBox="0 0 200 200">
        {renderCirclePaths(guide)}
      </svg>
    </div>
  );
};

export default GuideGraph;
